import { useEffect } from 'react';
import { useFormikContext } from 'formik';
import type { BlockerFunction } from 'react-router-dom';

import { isDefined } from '@e-socna/utils';

import { FormPrompt, FORM_PROMPT_DEFAULT_MESSAGE } from './FormPrompt';

export { FORM_PROMPT_DEFAULT_MESSAGE };

interface Props {
  readonly blockerFn?: (shouldBlock: boolean) => BlockerFunction;
  readonly mustBlock?: boolean;
  readonly setMustBlockAction?: (mustBlock: boolean) => void;
}

export const ConfirmBeforeExitForm = ({
  blockerFn,
  mustBlock: pMustBlock,
  setMustBlockAction,
}: Readonly<Props>) => {
  const { dirty, isSubmitting } = useFormikContext();

  const shouldBlock = !isDefined(pMustBlock)
    ? // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-conversion
      !!dirty && !isSubmitting
    : pMustBlock;

  useEffect(() => {
    setMustBlockAction?.(shouldBlock);
  }, [shouldBlock, setMustBlockAction]);

  return (
    <FormPrompt mustBlock={blockerFn ? blockerFn(shouldBlock) : shouldBlock} />
  );
};
